import { MarkerClusterer } from "@googlemaps/markerclusterer";

let $maps: Promise<typeof google> | null = null;

function initialize(apiKey: string) {
    return $maps ??= new Promise((resolve, reject) => {
        (window as any).googleMapsInitialized = () => resolve(google);
        var url = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=googleMapsInitialized`;
        var script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.src = url;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}

export class GmapsElement extends HTMLElement {
    markerCluster?: MarkerClusterer;

    async connectedCallback() {
        const $element = this;

        const google = await initialize($element.getAttribute('key')!);

        const map = new google.maps.Map($element, {
            center: {
                lat: +$element.getAttribute('lat')!,
                lng: +$element.getAttribute('lng')!,
            },
            zoom: +$element.getAttribute('zoom')!,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#616161"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#bdbdbd"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#757575"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#757575"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dadada"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#616161"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e5e5e5"
                        }
                    ]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#c9c9c9"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9e9e9e"
                        }
                    ]
                }
            ]
        })

        const markersJson = $element.getAttribute('markers');
        console.log('json', markersJson);
        if (markersJson) {
            const markers = JSON.parse(markersJson) as MarkerItem[];
            if (Array.isArray(markers)) {
                this.markerCluster = drawMarkers(map, markers)
            }
        }
    }

    disconnectedCallback() {
    }
}

customElements.define('g-maps', GmapsElement);


function drawMarkers(map: google.maps.Map, items: MarkerItem[]) {
    var infowindow = new google.maps.InfoWindow({
        content: null
    });

    var center = { lat: 0, lng: 0 };
    var markers = items.map(x => {
        center.lat += x.lat;
        center.lng += x.lng;
        return getMarker(x);
    });
    center.lat /= items.length;
    center.lng /= items.length;

    map.setCenter(new google.maps.LatLng(center.lat, center.lng));
    map.setZoom(10);

    const markerCluster = new MarkerClusterer({ map, markers });
    return markerCluster;

    function getMarker(item: MarkerItem) {
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(item.lat, item.lng)
        });

        const open = () => {
            infowindow.setContent(getInfoWindowContent(item));
            infowindow.open(map, marker);
        };
        marker.addListener('click', open);

        if (item.active) {
            open();
        }

        return marker;
    }

    function getInfoWindowContent(item: MarkerItem) {
        const div = make('div', { className: 'marker-infowindow rounded-4' }, [
            make('a', { href: item.href, className: 'd-flex' }, [
                make('img', { className: 'img-block rounded-4', src: item.image })
            ]),
            make('div', { className: 'item-title mt-2 mb-3' }, [
                item.title
            ]),
            make('div', { className: 'd-flex justify-content-end' }, [
                make('a', { className: 'btn btn-sm site-btn-primary', href: item.href }, [
                    item.button
                ])
            ])
        ])
        return div;
    }
}


function make<K extends keyof HTMLElementTagNameMap>(tag: K, attributes: Partial<HTMLElementTagNameMap[K]>, children?: (Node | string)[]): HTMLElementTagNameMap[K] {
    const e = document.createElement(tag);
    for (const [key, value] of Object.entries(attributes)) {
        (e as any)[key] = value;
    }
    children?.forEach(c => e.append(c))
    return e;
}

type MarkerItem = {
    title: string;
    image: string;
    href: string;
    lat: number;
    lng: number;
    button: string;
    active: boolean;
}